<template>
  <div class="category">{{ props.filterClass }}:</div>
  <select v-model="selectedType">
    <option value="">- - -</option>
    <option
      v-for="option in props.filterCategories"
      :value="option.categoryId"
      :key="option.categoryId"
    >
      {{ option.categoryText }}
    </option>
  </select>
</template>

<script setup>
import { defineProps, ref, watch, defineEmits } from "vue";

const props = defineProps(["filterClass", "filterCategories", "filterId"]);
const emits = defineEmits(["category-chosen"]);

const selectedType = ref("");

watch(selectedType, (newS) => {
  emits("category-chosen", [props.filterId, newS]);
});
</script>

<style scoped>
div {
  width: 50%;
  height: 3vh;
  align-items: end;
  text-transform: uppercase;
  font-family: var(--font-display);
}

select {
  width: 40%;
  margin: 1.5rem;
  text-transform: uppercase;
}
@media only screen and (max-width: 600px) {
  select {
    width: 50%;
  }
}
</style>
